import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { memberTypeView } from "../types/memberTypeView";
import {
  IMemberType,
  IMemberTypeGridFilter,
  IMemberTypeGridModel,
} from "./types";

export const memberType = createQueryKeys("memberType", {
  list: (postModel: PostModel<IMemberTypeGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IMemberTypeGridModel>>(
        endpoints.memberType.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IMemberType>(`${endpoints.memberType.getById}/${Id}`),
  }),

  getMemberTypeValues: () => ({
    queryKey: ["GetMemberTypeValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.memberType.getMemberTypeValues),
  }),

  getViewById: (Id: string | number | undefined) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<memberTypeView>(`${endpoints.memberType.view}/${Id}`),
  }),

  checkForMember: (Id: string | number | undefined) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<boolean>(`${endpoints.memberType.checkForMember}/${Id}`),
  }),
});
